// extracted by mini-css-extract-plugin
module.exports = {"secondFold":"secondFold_secondFold__OYijT","heading":"secondFold_heading__Nr6_w"};